module.exports = __webpack_public_path__ + "media/images/instructions/aws-iam-roles-5-review-6f484bafee459733bbffa1cebbe610b1.png";